import { render, staticRenderFns } from "./collectionreports.vue?vue&type=template&id=5e44f1d2&scoped=true&"
import script from "./collectionreports.vue?vue&type=script&lang=js&"
export * from "./collectionreports.vue?vue&type=script&lang=js&"
import style0 from "./collectionreports.vue?vue&type=style&index=0&id=5e44f1d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e44f1d2",
  null
  
)

export default component.exports